export const includes = <T>(array: T[], item: T): boolean => {
    return array.indexOf(item) !== -1;
};
